// Matches:  Last,First    Last, First    Last, First Middle
export const LAST_FIRST_REGEX = /^\s*(\w|\-)+\.?\s*\,\s*(\w|\-)+(\s+(\w|\-)+\.?)*\s*$/
export const FIRST_LAST_REGEX = /^\s*(\w|\-)+\s+(\w|\-)+(\s+(\w|\-)+\.?)?\s*$/

export const PHONE_REGEX = /(\+1)?[(]?\d{3}[)]?[(\s)?.-]?\d{3}[\s.-]?\d{4}/
export const LABELED_PHONE_REGEX = /((Cell|Home|Work|Wk|Hm)\:?\s*(\+\d+)?\s*\(?\s*\d\d\d\s*\)?\s*\-?\s*\d\d\d\s*\-\s*\d\d\d\d\s*)+/i

// Matches email address
export const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export const CODE_REGEX = /^[\w\s]+\[\d+\]$/i
